module.exports = __webpack_public_path__ + "media/images/review/ico-human-6d2dceb157b995f2d8860837cba76798.svg";